import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["simple-carousel"]
  static targets = ["pictures", "slideshow"]
  static values = { slidePosition: Number }


  connect() {
    this.scrollTopPosition = 0

    if (this.hasSlidePositionValue && this.slidePositionValue > 0) {
      this.openSlideshow()
      this.simpleCarouselOutlet?.goToSlide(this.slidePositionValue)
    } else {
      this.closeSlideshow()
    }

    this.setupEvents()
  }

  setupEvents() {
    this.previousButton?.addEventListener("click", this.onPreviousClick.bind(this))

    this.picturesTarget.querySelectorAll("img").forEach(image => {
      image.addEventListener("click", this.onPictureClick.bind(this))
    })
  }

  onPreviousClick(event) {
    event.preventDefault()
    this.closeSlideshow()
  }

  onPictureClick(event) {
    event.preventDefault()
    this.openSlideshow()
  }

  openSlideshow() {
    this.scrollTopPosition = this.scrollContainer?.scrollTop || 0
    this.element.classList.add("slideshow-open")
    this.showPreviousButton()
  }

  closeSlideshow() {
    this.element.classList.remove("slideshow-open")
    if (this.scrollContainer) this.scrollContainer.scrollTop = this.scrollTopPosition
    this.hidePreviousButton()
  }

  goToSlide(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    if (!isNaN(index)) {
      this.simpleCarouselOutlet?.goToSlide(index + 1) // assuming slides start at 1
    }
  }

  showPreviousButton() {
    this.previousButton?.classList.remove("d-none")
  }

  hidePreviousButton() {
    this.previousButton?.classList.add("d-none")
  }

  get previousButton() {
    return document.getElementById("gallery-display-all-button")
  }

  get scrollContainer() {
    return this.element.closest(".modal-body")
  }
}
